import React from 'react';
import { Button } from 'antd';
import { CheckCircleOutlined, EditOutlined } from '@ant-design/icons';
import { SettingsSaveBarStyle } from './styles';

type SettingsSaveBarProps = {
  isDirty: boolean;
  isSaving: boolean;
  canUpdate: boolean;
  disabled?: boolean;
  onReset: () => void;
  onReview: () => void;
};

export const SettingsSaveBar = (props: SettingsSaveBarProps): React.JSX.Element => {
  const { isDirty, isSaving, canUpdate, disabled, onReset, onReview } = props;
  return (
    <SettingsSaveBarStyle>
      <span className={`save-state${isDirty ? ' is-dirty' : ''}`} role="status">
        {isDirty ? <EditOutlined /> : <CheckCircleOutlined />}{' '}
        {isDirty ? '저장하지 않은 변경이 있습니다.' : '저장된 설정과 동일합니다.'}
      </span>
      {canUpdate && (
        <div className="save-actions">
          <Button disabled={!isDirty || isSaving} onClick={onReset}>
            변경 취소
          </Button>
          <Button type="primary" disabled={!isDirty || disabled} loading={isSaving} onClick={onReview}>
            변경 검토
          </Button>
        </div>
      )}
    </SettingsSaveBarStyle>
  );
};
